import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

//material ui components:
import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid';
import { withStyles } from '@material-ui/core/styles';

//styles:
const styles = theme => ({
    paperTitle: {
        fontSize: 13,
        fontWeight: '500',
        color: 'white',
        backgroundColor: theme.palette.primary.main,
        padding: '4px 2px 4px 12px',
        margin: 0,
    },
    paper: {
        backgroundColor: theme.palette.primary.light,
        boxShadow: 'none',
        borderBottom: '3px solid #b8b8b8',
        borderRight: '3px solid #b8b8b8',
        borderRadius: '0px',
        margin: '25px 0',
        padding: 10,
    },
    headerRow: {
        display: 'flex',
        justifyContent: 'space-between',
        backgroundColor: '#e6e6e6',
        padding: '4px 2px 4px 12px',
        borderBottom: '3px solid #b8b8b8',
    },
    headerRowItem: {
        fontSize: 13,
        fontWeight: '700',
        margin: 0,
        width: '50%',
        padding: '0 10px',
    },
    gridRow: {
        display: 'flex',
        justifyContent: 'space-between',
        fontSize: 11,
        padding: '2px 10px',
        borderBottom: '1px solid #8bc34a',
        "&:last-child": {
            borderBottom: 'none',
            paddingBottom: 3,
        },
    },
    rowItem: {
        width: '50%',
        padding: '0 10px',
        fontWeight: '500',
    },
    rtl: {
        textAlign: 'right',
    },
});


const Top5 = (props) => {

    const { classes } = props;

    return (

        <Grid item xs={8}>
            <Paper className={classes.container} elevation={0}>
                <h5 className={classes.paperTitle}>Top 5</h5>

                <div className={classes.headerRow}>
                    {/* header row */}
                    <h5 className={classes.headerRowItem}>Tipo de Partida</h5>
                    <h5 className={`${classes.headerRowItem} ${classes.rtl}`}>Total Partidas</h5>
                </div>
                    {props.top5.length ? props.top5.map((tp, i) =>

                        <div className={classes.gridRow} key={i}>
                            <div className={classes.rowItem}>{tp.descr ? tp.descr : ''}</div>
                            <div className={`${classes.rowItem} ${classes.rtl}`}>{tp.totalPartidas ? tp.totalPartidas.toFixed(2) : '0.00'}</div>
                        </div>
                    )
                        : <p style={{ padding: 10 }}>No hay partidas jugadas</p>
                    }
            </Paper>
        </Grid>

    );
};


Top5.propTypes = {
    top5: PropTypes.array.isRequired
};


function mapStateToProps(state) {
    return {
        top5: state.otrosDatosCierreDiario.top5,
    };
};


export default connect(mapStateToProps)(withStyles(styles, { withTheme: true })(Top5));